<template>
  <SiteHeader />
  <SiteBlobBanner
    title="Conditions Générales d'Utilisation"
  />
  <SiteCGU />
  <SiteFooter />
  <SitePostFooter />
</template>

<script setup>
  import SiteHeader from '@/sections/SiteHeader'
  import SiteCGU from '@/sections/cgu'
  import SiteBlobBanner from '@/sections/SiteBlobBanner'
  import SiteFooter from '@/sections/SiteFooter'
  import SitePostFooter from '@/sections/SitePostFooter'

  const { setSeoMeta } = useSeo()

  setSeoMeta({
    title: 'Conditions Générales d\'Utilisation - CRA Freelance',
    description: 'Conditions Générales d\'Utilisation de CRA Freelance, outil de gestion des CRA pour freelances en régie.',
    type: 'website',
    noIndex: true
  })

  definePageMeta({
    name: 'cgu',
    layout: 'site'
  })
</script>
